// ignore-string-externalization
import styled, { css } from 'styled-components';
import { spacer12, spacer20, spacer40, spacer64, white, IconMenu, IconX, Type, cssColorValue } from '@spotify-internal/encore-web';
import { getLinkStyle } from '../../ui';
var linkFocusStyle = css(["a:focus:not(:disabled),button:focus svg{outline:thin dotted ", ";}"], white);
export var OpenSideMenuButton = styled(IconMenu).withConfig({
  displayName: "NavSideMenustyles__OpenSideMenuButton",
  componentId: "sc-616ydx-0"
})(["vertical-align:top;transform:scale(1.25);&:hover{cursor:pointer;}"]);
export var CloseSideMenuButton = styled(IconX).withConfig({
  displayName: "NavSideMenustyles__CloseSideMenuButton",
  componentId: "sc-616ydx-1"
})(["position:absolute;top:", ";right:", ";color:", ";&:hover{cursor:pointer;}"], spacer12, spacer12, white);
export var SideMenuLink = styled(Type).attrs({
  variant: Type.heading3,
  weight: Type.bold
}).withConfig({
  displayName: "NavSideMenustyles__SideMenuLink",
  componentId: "sc-616ydx-2"
})(["", ""], linkFocusStyle);
export var SideMenuAction = styled(Type).attrs({
  variant: Type.heading3,
  weight: Type.book
}).withConfig({
  displayName: "NavSideMenustyles__SideMenuAction",
  componentId: "sc-616ydx-3"
})(["", ""], linkFocusStyle);
export var SidemenuSeparator = styled.div.withConfig({
  displayName: "NavSideMenustyles__SidemenuSeparator",
  componentId: "sc-616ydx-4"
})(["width:", ";height:0;border-top:1px solid ", ";margin-top:", ";margin-bottom:", ";"], spacer40, cssColorValue('decorativeSubdued'), spacer12, spacer12);
export var SideMenuCategory = styled(Type).attrs({
  variant: Type.heading3,
  weight: Type.bold
}).withConfig({
  displayName: "NavSideMenustyles__SideMenuCategory",
  componentId: "sc-616ydx-5"
})(["", ""], linkFocusStyle);
export var SideMenuCategoryTitle = styled(Type).attrs({
  variant: Type.heading3,
  weight: Type.bold
}).withConfig({
  displayName: "NavSideMenustyles__SideMenuCategoryTitle",
  componentId: "sc-616ydx-6"
})(["svg{margin-left:", ";vertical-align:baseline;}"], spacer12);
export var SideMenuCategoryItem = styled(Type).attrs({
  variant: Type.body1,
  weight: Type.book
}).withConfig({
  displayName: "NavSideMenustyles__SideMenuCategoryItem",
  componentId: "sc-616ydx-7"
})([""]);
export var StyledSideMenu = styled.nav.withConfig({
  displayName: "NavSideMenustyles__StyledSideMenu",
  componentId: "sc-616ydx-8"
})(["position:fixed;top:0;right:0;bottom:0;width:320px;padding:", " ", " ", " ", ";background:", ";z-index:1041;overflow:auto;display:flex;flex-direction:column;&,a,a:visited,button span,button svg{color:", ";}", "{a,button{", "}}ul{display:flex;flex-direction:column;flex:1;li{width:100%;margin-bottom:", ";ul{margin-top:", ";padding-bottom:0;li{margin-left:", ";}li:last-child{margin-bottom:0;}}}}ul,ol{list-style:none;padding-left:0;}"], spacer64, spacer20, spacer20, spacer20, function (props) {
  return props.theme.nav.sideMenuBackground;
}, function (props) {
  return props.theme.nav.sideMenuTextColor;
}, SideMenuCategory, function (props) {
  return getLinkStyle(props);
}, spacer20, spacer20, spacer20);